<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Api V1 - Único Tracker</h3>
      </div>
      <div class="box-content">
        <p>
          Esta é uma api aberta da Único Tracker. Onde você pode <b>Consultar / Inserir</b> dados de: Venda, Produto, Marketing, Lead.
        </p>
        <p class="margin-top-s">
          Para ler a documentação acesse: <a href="https://dev.unicotracker.com.br" target="_blank">https://dev.unicotracker.com.br</a>
        </p>
        <p class="margin-top-s">
          <b>Atenção:</b> O Acesso a API é liberado apenas para assinantes de planos pagos.
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Token de Acesso</label>
              <input class="input readonly" type="text" v-model="token" readonly/>
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="showModal = true">
                Gerar novo Token
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

      <!-- modal confirm delete -->
      <modal-confirm
        :show="showModal"
        description="Você tem certeza que deseja gerar um novo Token?"
        @cancel="
          showModal = false;
        "
        @accept="updateTokenApi()"
      ></modal-confirm>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";

import ModalConfirm from "@/components/modal/ModalConfirm";

export default {
  name: "open-api",
  components: {
    ModalConfirm
  },
  data() {
    return {
      showModal: false,
      token: ''
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    updateTokenApi() {
      let params = {
        'openapiv1': {
          'token': true
        }
      }
      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Novo token gerado com sucesso",
          });

          this.showModal = false

          this.getIntegrations()
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar criar novo token",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.token = result.openapiv1.token;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.input.readonly {
  background: #f5f4f4 !important;
}
</style>
